"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouriteApplicationStatusChanged = void 0;
const wishlist_event_1 = require("./wishlist-event");
class FavouriteApplicationStatusChanged extends wishlist_event_1.WishlistEvent {
    constructor(userId, studyId, applicationStatus, eventId, stateHash, timestamp, isLocal) {
        super(timestamp);
        this.userId = userId;
        this.studyId = studyId;
        this.applicationStatus = applicationStatus;
        this.eventId = eventId;
        this.stateHash = stateHash;
        this.timestamp = timestamp;
        this.isLocal = isLocal;
        this.eventType = FavouriteApplicationStatusChanged.EventType;
        this.eventVersion = '1.0.0';
    }
    static create(userId, studyId, applicationStatus, stateHash, timestamp = new Date(), isLocal) {
        return new FavouriteApplicationStatusChanged(userId, studyId, applicationStatus, wishlist_event_1.WishlistEvent.generateId(), stateHash, timestamp, isLocal);
    }
}
exports.FavouriteApplicationStatusChanged = FavouriteApplicationStatusChanged;
FavouriteApplicationStatusChanged.EventType = 'FavouriteApplicationStatusChanged';
